angular.module('callX').controller('PromoGranularReportsCtrl', ['$scope', '$stateParams', 'DateService', 'ReportsService','ngAudio', function($scope, $stateParams, DateService, ReportsService,ngAudio) {

    var _userId = $stateParams.userId;
    var rankBy = $stateParams.rankBy;
    var state = $stateParams.state;
    var dayPart = $stateParams.dayPart;
    $scope.activeData = $stateParams.activeData;
    $scope.gId = $stateParams.gId;
    $scope.callType = $stateParams.callType;
    $scope.name = $stateParams.name;

    $scope.promoGranularList = [];
    $scope.tableContentLoading = false;

    var init = function(){
        var TempDateObj = DateService.getDateObj();
        if(TempDateObj.timezone!=undefined){
            $scope.fetchPromoGranularData(TempDateObj.activeDate, TempDateObj.dateRangeValue);
        }
    };

    $scope.orderParam = 'publisher_revenue';
    $scope.reverse = true;
    $scope.order = function(orderParam) {
        $scope.reverse = ($scope.orderParam === orderParam) ? !$scope.reverse : false;
        $scope.orderParam = orderParam;
    };

    var fetchPromoGranularDataList = function(activeDate, dateRangeValue){
        $scope.tableContentLoading = true;
        var callbacks = {
            success: function(data) {
                $scope.promoGranularList = data.data.calls;
                for(var i = 0; i < $scope.promoGranularList.length; i++){
                    $scope.promoGranularList[i].va_duration = parseInt($scope.promoGranularList[i].duration);
                    $scope.promoGranularList[i].va_connected_duration = parseInt($scope.promoGranularList[i].connected_duration);
                    $scope.promoGranularList[i].va_ivr_duration = parseInt($scope.promoGranularList[i].ivr_duration);
                    $scope.promoGranularList[i].va_publisher_revenue = parseInt($scope.promoGranularList[i].publisher_revenue);           
                }
                $scope.recordingVariable = data.data.user.recording;
//                console.log($scope.recordingVariable,"this is recording varibale");
                $scope.tableContentLoading = false;
            },
            failure: function(data) {
                $scope.tableContentLoading = false;
            }
        };
        ReportsService.getPromoGranularData(_userId, $scope.activeData, activeDate, dateRangeValue, rankBy, $scope.gId, $scope.callType, state, dayPart, callbacks);
    };

    $scope.fetchPromoGranularData = function(activeDate, dateRangeValue){
        fetchPromoGranularDataList(activeDate, dateRangeValue);
    };

    $scope.$on('dateObjUpdate', function(event, dateObj) {
        $scope.fetchPromoGranularData(dateObj.activeDate, dateObj.dateRangeValue);
    });
    init();

    $scope.goBack = function(){
        window.history.back();
    }

    $scope.playCallRecording = function (url) {
        if($scope.sound!=undefined){
            $scope.sound.stop();
        }
        $scope.sound = ngAudio.load(url);
        $scope.sound.play();
    };

    $scope.pauseCallRecording = function(){
        $scope.sound.pause();
    };

    $scope.resumeCallRecording = function(){
        $scope.sound.play();
    };
}]);